<template>
    <div :class="open ? 'faq open' : 'faq'" >
        <div class="question" @click="$emit('toggleOpen', index)">{{ faq.question }}</div>
        <div class="answers" v-html="faq.answer">{{ faq.answer }}</div>
    </div>
</template>

<script>

export default {
  name: 'FAQ',
  props: ['faq', 'index', 'open']

}
</script>

<style lang="scss"  >
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;700&display=swap');

  $base-font-size-px: 16px;
  $base-font-size-em: 1em;
  $base-font-family: 'Roboto',
  sans-serif;
  $base-line-height: 1.2em;

.FAQ-container {
    /* // text-align: center; */
  background-color: #232323;
  padding: 100px 50px;

  box-sizing: border-box;
    /* // height: 100vh; */
  .faq-wrapper {
    max-width: 1240px;
  width: 100%;
  margin: auto;
  }
  .FAQ-title {
    color: #fff;
    font-size: $base-font-size-em * 3;
    margin: auto auto 40px auto;
    max-width: 1021px;

  }
}
.faq {
  display: block;
  width: 100%;
  max-width: 1021px;
  margin: 0 auto;
  padding-bottom: 10px;
  cursor: pointer;
}

.faq::before {
   content: '';
    width: 100%;
    background: #FFFFFF;
    opacity: 0.2;
    height: 0.5px;
    display: block;
    margin-bottom: 10px;
}

.faq:last-child::after {
   content: '';
    width: 100%;
    background: #FFFFFF;
    opacity: 0.2;
    height: 0.5px;
    display: block;
    margin-top: 15px;
}

.faq .question {
  position: relative;
  margin-right: 80px;
  color: #fff;
  font-size:$base-font-size-em*1.375;
  font-family:$base-font-family;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0.42;
}

.faq .question::before {
  content: '';
  position: absolute;
  top: 50%;
  right: -84px;
  transform: translateY(-50%) rotate(0deg);
  width: 12px;
  height: 12px;
  background-image: url('../assets/icon-plus.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all 0s linear;
}

.faq .question::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -84px;
  transform: translateY(-50%) rotate(0deg);
  width: 12px;
  height: 12px;
  background-image: url('../assets/icon-minus.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.faq.open .question {
  margin-bottom: 15px;
}

.faq.open .question::before {
  opacity: 0;
}

.faq .answers {
  color: rgba(255,255,255,0.7);
  font-size:$base-font-size-em*1.375;
  font-family:$base-font-family;
  line-height: 30px;
  font-weight: 300;
  letter-spacing: 0.42px;
  max-height: 0px;
  margin-right: 64px;
  // padding-bottom: 10px;
  overflow-y: hidden;
  cursor: text;
}

.faq.open .answers {
  opacity: 1;
  padding-bottom: 10px;
  max-height: 1000px;
}

@media screen and (max-width: 769px) {
  .faq {
    .question, .answers {
      font-size: $base-font-size-em * 1;
      margin-right: 20px;
    }
    .question::before, .answers::before, .question::after, .answers::after {
      right: -21px;
    }
  }
}

@media screen and (max-width: 450px) {
  .faq {
    .question, .answers {
      font-size: $base-font-size-em * 0.8125;
      line-height: 16.91px;
    }
  }
}
</style>
